var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBeforeAndAfterActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.646,
    height: 16,
    viewBox: "0 0 17.646 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:none;stroke:#326fff;stroke-miterlimit:10;}.b{fill:#326fff;}.c{stroke-linecap:round;stroke-dasharray:2.4 2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.511,1.632H22.35a1.222,1.222,0,0,1,1.222,1.222V14.148A1.222,1.222,0,0,1,22.35,15.37H16.511",
    transform: "translate(-6.425 -0.962)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.779,15.479H1.222A1.221,1.221,0,0,1,0,14.257V2.367A1.221,1.221,0,0,1,1.222,1.145H7.779Z",
    transform: "translate(0 -0.772)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    y2: 15,
    transform: "translate(9.018)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBeforeAndAfterActive);
export default __webpack_public_path__ + "static/media/icon_before_and_after_active.7f51df9912ad63bd9437af2932c8ebb7.svg";
export { ForwardRef as ReactComponent };